"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSquare = exports.StylePlaceholder = exports.StyleLabel = exports.StyleInput = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleLabel = exports.StyleLabel = _styledComponents.default.label.withConfig({
  displayName: "StyleLabel",
  componentId: "sc-1au4j88-0"
})(["display:flex;align-items:center;position:relative;padding-right:10px;@media ", ",", "{padding-right:24px;}"], _responsive.default.lg, _responsive.default.md);
const StyleInput = exports.StyleInput = _styledComponents.default.input.withConfig({
  displayName: "StyleInput",
  componentId: "sc-1au4j88-1"
})(["position:absolute;left:0;top:0;opacity:0;&:checked{+ div{border-color:transparent;background-color:", ";svg{fill:", ";}}}"], (0, _color.default)('primary'), (0, _color.default)('white'));
const StyleSquare = exports.StyleSquare = _styledComponents.default.div.withConfig({
  displayName: "StyleSquare",
  componentId: "sc-1au4j88-2"
})(["width:18px;height:18px;border:2px solid ", ";display:flex;align-items:center;justify-content:center;border-radius:100%;transition:border-color 0.3s,background-color 0.3s;flex:0 0 18px;svg{flex:1;fill:transparent;transition:fill 0.3s;}"], _ref => {
  let {
    error,
    disabled
  } = _ref;
  return error ? "".concat((0, _color.default)('error')) : !disabled ? "".concat((0, _color.default)('gray')) : "".concat((0, _color.default)('gray-4'));
});
const StylePlaceholder = exports.StylePlaceholder = _styledComponents.default.div.withConfig({
  displayName: "StylePlaceholder",
  componentId: "sc-1au4j88-3"
})(["padding-left:5px;font-weight:400;font-size:1.2rem;line-height:150%;color:", ";@media ", ",", "{font-weight:500;padding-left:12px;font-size:1.6rem;}"], _ref2 => {
  let {
    error
  } = _ref2;
  return error ? "".concat((0, _color.default)('error')) : "".concat((0, _color.default)('gray'));
}, _responsive.default.lg, _responsive.default.md);